import { parse, isValid } from "date-fns";
import * as z from "zod";

const messages = {
  requiredField: "Campo obrigatório",
  minCharacters: (num) => `Mínimo de ${num} caracteres`,
  maxCharacters: (num) => `Máximo de ${num} caracteres`,
  exactCharacters: (num) => `Deve conter ${num} caracteres`,
  invalidUrl: "Link inválido",
  invalidDate: "Data inválida",
};

const dateString = z
  .string({ message: messages.requiredField })
  .max(500, {
    message: messages.maxCharacters(500),
  })
  .refine(
    (val) => {
      try {
        const date = parse(val, "yyyy-MM-dd", new Date());
        return isValid(date);
      } catch {
        return false;
      }
    },
    {
      message: messages.invalidDate,
    },
  );

const ProjectDateValidator = {
  name: z
    .string({ message: messages.requiredField })
    .min(2, { message: messages.minCharacters(5) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  date: dateString,
  // Término do evento (D5, 29/08/2026): obrigatório como o início.
  finish_date: dateString,
};

export default ProjectDateValidator;
